// @ts-nocheck
import { notesStyles, RequestRmaNotesStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaNotes";
import { css } from "styled-components";

Object.assign(notesStyles, {
    wrapper: {
        css: css`
            ${notesStyles.wrapper?.css};
            width: 100%;
        `,
    },
} as RequestRmaNotesStyles);
